import React from 'react'
import { Select } from "antd";


export default class FeedBackSelect extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        let { questionTypes, questionTypesIndex, tempText, onSelect } = this.props
        return <div className='selectBtnWrap'>
            <Select
                className='customerServiceSelect'
                dropdownClassName='customerServiceSelectDropdown'
                defaultValue={questionTypesIndex >= 0 ? questionTypes[questionTypesIndex]?.questionType : tempText?.text17}
                showArrow={true}
                style={{ width: '100%', marginLeft: 0, height: '40px' }}
                onSelect={(value, { key }) => {
                    onSelect({
                        questionTypesIndex: key,
                        isQuestionModalVisible: false
                    })
                }}>
                {
                    questionTypes.map((v, i) => {
                        let flag = questionTypesIndex == i
                        return <Option
                            key={i}
                            value={v?.questionType}
                            className='selectOption'
                            style={{
                                background: flag ? '#EFEFF4' : 'transparent'
                            }}
                        >{v?.questionType}</Option>
                    })
                }
            </Select>
        </div>
    }
}